import { isDefined } from 'ionic-angular/util/util';
import { VASRestService } from '../../core/services/api/vas-rest';
import { File } from '../../vas/business-objects/file/file.model';
import { UniversalFilesystemService } from '../../vas/services/universal-filesystem/universal-filesystem.service';
import { FileReaderHelper } from './file-system/file-reader.helper';
import { FileHelper, PathInfoType } from './file-system/file.helper';

enum BrowserStorageTypeEnum {
    PERSISTENT = 1
}

export interface FileSystemUsage {
    quota: number;
    usage: number;
}

export class FileSystemHelper {

    /**
     * Returns a data url from the blob
     * @param blob
     * @returns {Promise<string>}
     */
    static blobToDataUrl(blob: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = FileReaderHelper.getFileReader();
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.onerror = error => {
                reject(error);
            };
            reader.readAsDataURL(blob);
        });
    }

    /**
     * This method converts a blob to a base64 encoded string which can be used
     * with Ionic Email composer (native share)
     * See https://ionicframework.com/docs/v3/native/email-composer/
     * @param blob {Blob}
     * @param filename {string}
     */
    static blobToAttachmentUrl(blob: Blob, filename: string): Promise<string> {

        return new Promise((resolve, reject) => {
            FileSystemHelper.blobToDataUrl(blob).then(
                dataUrl => {
                    const attachmentUrl = [
                        'base64:',
                        filename.replace(/[/\s]/g, '-').toLowerCase(),
                        '//',
                        dataUrl.substring(dataUrl.indexOf(',') + 1)
                    ].join('');
                    resolve(attachmentUrl);
                },
                reject
            );
        });
    }

    static blobToObjectUrl(blob): string {
        return URL.createObjectURL(blob);
    }

    static pathToBlob(path: string): Promise<Blob> {
        return FileSystemHelper.objectUrlToBlob(path);
    }

    static objectUrlToBlob(objectUrl: string): Promise<Blob> {
        return fetch(objectUrl).then(response => response.blob());
    }

    static objectUrlToBlob2(objectUrl: string): Promise<Blob> {
        return new Promise<Blob>((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', objectUrl, true);
            xhr.responseType = 'blob';
            // tslint:disable-next-line:space-before-function-paren
            xhr.onload = function (e): void {
                // tslint:disable-next-line:static-this no-invalid-this
                const _this = this as any;
                if (_this.status !== 200) {
                    reject(Error('Error reading objectUrl'));
                    return;
                }
                resolve(_this.response);
            };

            xhr.onerror = error => {
                reject(new Error(`error reading objectUrl`));
            };
            xhr.onabort = error => {
                reject(new Error(`error reading objectUrl`));
            };

            xhr.send();
        });
    }

    /**
     * Converts a base64 string to a Blob
     * @param b64Data
     * @param contentType
     * @param sliceSize
     * @returns {Blob}
     * https://gist.github.com/fupslot/5015897
     */
    static b64ToBlob(b64Data, contentType = '', sliceSize = 512): Blob {

        const byteString = atob(b64Data);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ab], {type: contentType});
    }

    static async getFileSystemUsage(): Promise<FileSystemUsage> {

        if (!isDefined(navigator) || !isDefined((navigator as any).storage) || !isDefined((navigator as any).storage.estimate)) {
            return {
                quota: 0,
                usage: 0
            };
        }

        return (navigator as any).storage.estimate();
    }

    static requestQuota(quota = 1024 * 1024): Promise<number> {
        return new Promise((resolve, reject) => {
            (window as any).webkitStorageInfo.requestQuota(
                BrowserStorageTypeEnum.PERSISTENT,
                quota,
                resolve,
                reject
            );
        });
    }

    static requestFileSystem(grantedBytes: number = 1024 * 1024): Promise<any> {

        const fs = (window as any).requestFileSystem || (window as any).webkitRequestFileSystem;

        return new Promise((resolve, reject) => {
            fs(BrowserStorageTypeEnum.PERSISTENT, grantedBytes, filesystem => {
                // fs = filesystem;
                console.log(filesystem);
                resolve(filesystem);
            }, reject);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/file-system.helper.ts